import { useContext } from 'react'
import { UserContext } from 'contexts/user'
import { URL_RENOVADOR } from 'config'
import { useVisitedLoanStore } from 'store'
import { trackEvent } from 'analytics/trackFunctions'

import { Tab } from '@headlessui/react'

import WalletIllus from 'assets/images/wallet-illus.png'

import FirstTimeInLoanSection from '../FirstTimeInLoanSection'
import CreditHistory from './CreditHistory'

const LoansTab = () => {
  const { hasVisitedLoan, updateHasVisitedLoan } = useVisitedLoanStore()

  return (
    <Tab.Panel
      unmount
      className='min-h-64 md:max-h-[calc(100vh_-_28rem)] space-y-3 p-1 md:overflow-y-auto'
    >
      <LoanBanner />
      <CreditHistory product='LOANS' />
      <FirstTimeInLoanSection
        setHasVisited={updateHasVisitedLoan}
        isOpen={!hasVisitedLoan}
      />
    </Tab.Panel>
  )
}

export default LoansTab

const LoanBanner = () => {
  const { user } = useContext(UserContext)

  return (
    <button
      className='w-full rounded-[10px] h-20 gap-2 grid grid-cols-personalAdvisor items-center px-4 cursor-pointer bg-blue-100 text-purple-900'
      onClick={() => {
        trackEvent({ eventName: 'bille_banner_prestamos' })
        window
          .open(
            `${URL_RENOVADOR}iniciando?access_token=${user.access_token}`,
            '_blank'
          )
          .focus()
      }}
    >
      <p className='text-xs text-left font-bold leading-5'>
        Comprá eso que querés con un <br /> préstamo a la mejor tasa
      </p>
      <div className='flex items-center justify-end'>
        <img
          alt=''
          src={WalletIllus}
          className='transform scale-125 rotate-12'
        />
      </div>
    </button>
  )
}
